import { render, staticRenderFns } from "./UploadingImage.vue?vue&type=template&id=96441b6c"
import script from "./UploadingImage.vue?vue&type=script&lang=js"
export * from "./UploadingImage.vue?vue&type=script&lang=js"
import style0 from "./UploadingImage.vue?vue&type=style&index=0&id=96441b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports